/**
 * Created by n.rusev on 13/3/2019.
 */
const documentedProperties = [
    {
        name: "children",
        type: "React.Children",
        defaultValue: "n/a",
        isRequired: "true",
        description: "Col component nests your content, so some children are expected."
    },
    {
        name: "extraClasses",
        type: "String",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Extra css classes to be append to Col's className."
    },
    {
        name: "lg",
        type: "Number",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Defines the large size of the column. Expected number between 1 and 12."
    },
    {
        name: "md",
        type: "Number",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Defines the medium size of the column. Expected number between 1 and 12."
    },
    {
        name: "sm",
        type: "Number",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Defines the small size of the column. Expected number between 1 and 12."
    },
    {
        name: "offsetWhenLarge",
        type: "Number",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Defines the offset of the column on large resolutions."
    },
    {
        name: "offsetWhenMedium",
        type: "Number",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Defines the offset of the column on medium resolutions."
    },
    {
        name: "offsetWhenSmall",
        type: "Number",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Defines the offset of the column on small resolutions."
    },
    {
        name: "gutterAll",
        type: "[1,2,3]",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Re-defines the Col gutters. The value represents the size of the gutter."
    },
    {
        name: "gutterLeft",
        type: "[1,2,3]",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Re-defines the Col left gutters. The value represents the size of the gutter."
    },
    {
        name: "gutterRight",
        type: "[1,2,3]",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "Re-defines the Col right gutters. The value represents the size of the gutter."
    },
    {
        name: "gutterTop",
        type: "[1,2,3]",
        defaultValue: "n/a",
        isRequired: "false",
        description: "Re-defines the Col top gutters. The value represents the size of the gutter."
    },
    {
        name: "gutterBottom",
        type: "[1,2,3]",
        defaultValue: "n/a",
        isRequired: "false",
        description:
            "Re-defines the Col bottom gutters. The value represents the size of the gutter."
    },
    {
        name: "skipGutter",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description:
            "By default grid define left and right padding. If skipGutter is set, it removes this padding."
    },
    {
        name: "skipGutterLeft",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description:
            "By default grid define left and right padding. If skipGutterLef is set, it removes the left padding."
    },
    {
        name: "skipGutterLeft",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description:
            "By default grid define left and right padding. If skipGutterRight is set, it removes the right padding."
    },
    {
        name: "hideWhenLarge",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "Hide column on large screen size"
    },
    {
        name: "hideWhenMedium",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "Hide column on medium screen size"
    },
    {
        name: "hideWhenSmall",
        type: "Boolean",
        defaultValue: "false",
        isRequired: "false",
        description: "Hide column on small screen size"
    },
    {
        name: "pushWhenLarge",
        type: "Number",
        defaultValue: "none",
        isRequired: "false",
        description:
            "Pushes the column position with number distance to the right when on large screen size"
    },
    {
        name: "pushWhenMedium",
        type: "Number",
        defaultValue: "none",
        isRequired: "false",
        description:
            "Pushes the column position with number distance to the right when on medium screen size"
    },
    {
        name: "pushWhenSmall",
        type: "Number",
        defaultValue: "none",
        isRequired: "false",
        description:
            "Pushes the column position with number distance to the right when on small screen size"
    },
    {
        name: "pullWhenLarge",
        type: "Number",
        defaultValue: "none",
        isRequired: "false",
        description:
            "Pulls the column position with number distance to the left when on large screen size"
    },
    {
        name: "pullWhenMedium",
        type: "Number",
        defaultValue: "none",
        isRequired: "false",
        description:
            "Pulls the column position with number distance to the left when on medium screen size"
    },
    {
        name: "pullWhenSmall",
        type: "Number",
        defaultValue: "none",
        isRequired: "false",
        description:
            "Pulls the column position with number distance to the left when on small screen size"
    },
    {
        name: "justifyContent",
        type: "String",
        defaultValue: "left",
        isRequired: "false",
        description:
            "Specifies how to justify Col's children. Supported justification are 'left', 'right', 'center', 'bottom-left', 'bottom-center', 'bottom-right'."
    }
];

export default documentedProperties;
